import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/aidyn/server/projects/optovichok/frontend/src/app/product-catalog/components/ProductCatalogInteractive.tsx");
